import { PhoneIncoming, X } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function CallPopup({ call, onClose, onOrder }) {
  return (
    <div className="fixed bottom-6 right-6 z-50 w-[340px] rounded-3xl bg-[#0F1F45] text-white shadow-2xl p-5 rise" data-testid="caller-popup">
      <button onClick={onClose} className="absolute top-4 right-4 text-white/60 hover:text-white" data-testid="caller-popup-close-btn"><X className="h-4 w-4" /></button>
      <div className="flex items-center gap-3">
        <div className="h-12 w-12 rounded-2xl bg-[#FF6B0A] grid place-items-center ringing"><PhoneIncoming /></div>
        <div>
          <p className="text-xs text-white/60">Gelen arama</p>
          <p className="font-mono-num text-xl font-bold" data-testid="caller-popup-phone">{call.phone}</p>
        </div>
      </div>
      <div className="mt-4 rounded-2xl bg-white/10 p-3 text-sm">
        {call.name ? (
          <>
            <p className="font-semibold" data-testid="caller-popup-name">{call.name}</p>
            <p className="text-white/70 text-xs mt-1">{call.address || "Adres yok"}</p>
            <p className="text-[#FFB27A] text-xs mt-1">{call.order_count} önceki sipariş</p>
          </>
        ) : <p className="text-white/70">Yeni müşteri</p>}
      </div>
      <Button className="mt-4 w-full rounded-full bg-[#FF6B0A] hover:bg-[#E55A00]" onClick={onOrder} data-testid="caller-popup-order-btn">Sipariş Oluştur</Button>
    </div>
  );
}
